<template>
  <vue-modal :active="active" container-class="bg-smoke" @closed="$emit('closed')">
    <div class="box p-0">
      <recurrence-form :model="recurrence"
                       :resource="resource"
                       :action="action"
                       :canUpdate="canUpdate"
                       :canDelete="canDelete"
                       @created="handleCreated"
                       @updated="handleUpdated"
                       @deleted="handleDeleted"/>
    </div>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import resource from '../../mixins/resource';
import RecurrenceForm from './RecurrenceForm.vue';

export default {
  mixins: [modal, resource],

  components: { RecurrenceForm },

  computed: {
    recurrence() {
      return this.data;
    },
    resource() {
      return 'recurrences';
    },
  },

  methods: {
    handleCreated(recurrence) {
      Event.fire('recurrenceCreated', recurrence);
    },
    handleUpdated(recurrence) {
      Event.fire('recurrenceUpdated', recurrence);
    },
    handleDeleted(recurrence) {
      Event.fire('recurrenceDeleted', recurrence);
    },
  },
};
</script>